<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ilDOv/tc-custom/9781429998475.jpg?1737777143200" alt="This image is the cover for the book Tasting the Sky"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tasting the Sky
      </h1>
      <p class="bookDescription body article font2">
        <b>“A spare elegant memoir. . . . The immediacy of the child’s viewpoint . . . depicts both conflict and daily life without exploitation or sentimentality.” —<i>Booklist</i>, starred review</b><br/><br/><i>“When a war ends it does not go away,” my mother says. “It hides inside us . . . Just forget!”</i><br/><br/><i>But I do not want to do what Mother says . . . I want to remember.</i><br/><br/>In this groundbreaking memoir set in Ramallah during the aftermath of the 1967 Six-Day War, Ibtisam Barakat captures what it is like to be a child whose world is shattered by war. With candor and courage, she stitches together memories of her childhood: fear and confusion as bombs explode near her home and she is separated from her family; the harshness of life as a Palestinian refugee; her unexpected joy when she discovers Alef, the first letter of the Arabic alphabet. This is the beginning of her passionate connection to words, and as language becomes her refuge, allowing her to piece together the fragments of her world, it becomes her true home.<br/><br/>Transcending the particulars of politics, this illuminating and timely book provides a telling glimpse into a little-known culture that has become an increasingly important part of the puzzle of world peace.<br/><br/><b>Winner, Arab American National Museum Book Award for Children’s/YA Literature</b><br/><br/>“Beautifully crafted. Readers will be charmed by the writer-to-be as she falls in love with chalk, the Arabic alphabet, and the first-grade teacher who recognizes her abilities.” —<i>School Library Journal</i>, starred review<br/><br/>“A compassionate, insightful family and cultural portrait.” —<i>Kirkus Reviews</i>, starred review<br/><br/>“Brims with tension and emotion.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ibtisam Barakat
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5034e5c4